<template>
  <router-view class="h-100"></router-view>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
export default {
  name: 'SingleTournament',
  computed: {
    ...mapGetters([
      'currentTournament',
      'isTournamentBackuped',
      'currentTournamentStage',
      'currentTournamentStages',
    ]),
    tournamentID() {
      return this.$route.params.tournamentID;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!to.params.tournamentID) {
      this.clearCurrentTournament();
      this.clearAllStages();
      this.clearAllBlocks();
    }
    this.clearCurrentTournamentBackup();
    next();
  },
  created() {
    if (this.tournamentID) {
      this.updateStageLoader(true);
      Promise.all([
        this.$store.dispatch('fetchTournament', this.tournamentID),
        this.$store.dispatch('fetchTournamentStages', this.tournamentID),
      ])
        .then(() => {
          if (
            this.$route.params.stageID &&
            this.currentTournamentStage.id !== this.$route.params.stageID
          ) {
            this.setCurrentTournamentStage(this.$route.params.stageID);
          }
          return this.currentTournamentStages.map(stage => {
            return this.fetchTournamentBlocks({
              stage: stage.index,
            }).then(blocks => {
              this.setTournamentBlocks(blocks);
            });
          });
        })
        .then(blocksPromises =>
          Promise.all(blocksPromises).catch(this.errorNotify)
        )
        .then(() => {
          if (this.isTournamentBackuped) {
            this.backupCurrentTournament();
          }
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.updateStageLoader(false);
        });
      this.fetchGames();
      this.fetchPlatforms();
    }
  },
  methods: {
    ...mapActions([
      'fetchTournamentBlocks',
      'fetchGames',
      'fetchPlatforms',
      'errorNotify',
    ]),
    ...mapMutations([
      'setTournamentBlocks',
      'backupCurrentTournament',
      'clearCurrentTournament',
      'clearCurrentTournamentBackup',
      'clearAllStages',
      'clearAllBlocks',
      'updateStageLoader',
      'setCurrentTournamentStage',
    ]),
  },
};
</script>
